import React, { useEffect } from "react";

import GUIDE from "@/assets/guide_share.png";
import SHOP from "@/assets/icon_shop.png";
import SWITCH from "@/assets/icon_switch.png";
import IWechat from "@/assets/icon_wechat.png";
import { UseUserInfoContext } from "@/pages/my/hooks/useUserInfo";
import { useCommonContext } from "@/utils/context/common";
import { Toast } from "antd-mobile";
import copy from "copy-to-clipboard";
import { useSearchParams } from "react-router-dom";
import { btn_click } from "../../track";
import BindPhonePopup from "../bind-phone-popup";
import RoleSwitchPopup from "../role-switch-popup";
import ShopOwnerQrcode from "../shop-owner-qrcode";
import styles from "./index.module.less";
interface IProps {
  userinfo: any;
  shareInfo: any;
  labelViewInfo: any;
}

// C用户信息卡片
const UserInfo: React.FC<IProps> = ({ userinfo, shareInfo, labelViewInfo }) => {
  const { handleSwitchRole } = UseUserInfoContext();
  const { isExternal, userVisitInfo } = useCommonContext();

  const defaultAvatarUrl =
    "https://akim-oss.aikucun.com/5adcf16a0a72ef9926af328220068b695fd489a5_1703043623267_78.png";
  const [showGuide, setShowGuide] = React.useState(false);
  // const [contactVisible, setContactVisible] = React.useState(false);
  const [roleSwitchPoupVisible, setRoleSwitchPoupVisible] = React.useState(false);
  const [bindPhonePopupVisible, setBindPhonePopupVisible] = React.useState(false);
  const [searchParams] = useSearchParams();
  const shopId = searchParams.get("shopId");
  const distributorId = searchParams.get("distributorId");

  // 联系店主
  // const handleClickContact = () => {
  //   setContactVisible(true);
  //   btn_click("我的-头部功能区", "联系店主");
  // };

  /**
   * 分享店铺，拉起H5页面分享引导提示
   * （店主是通过分享海报分享店铺的，C用户是直接通过H5页面自带的“分享”能力分享的）
   */
  const handleClickShare = () => {
    setShowGuide(true);
    btn_click("我的-头部功能区", "分享店铺码");
  };

  /**
   * 切换身份弹窗内点确认按钮
   * @param switchedRole 目标身份
   */
  const handleRoleSwitchConfirm = switchedRole => {
    setRoleSwitchPoupVisible(false);
    if (switchedRole === 1) {
      return;
    }
    handleSwitchRole(switchedRole);
  };

  // 授权获取openId
  const toAuth = (hasScope = true) => {
    let url = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    // 处理微信自动添加字符串问题，替换为空
    url = url.replace(/\/\?from=(message|timeline|singlemessage|groupmessage)(\S*)#/, "/#");
    url = url.replace(/\/\?(scene|subscene|clicktime)=[\d]+(\S*)#/, "/#");
    // eslint-disable-next-line no-restricted-syntax
    window.location.href = `/api/member/auth?${hasScope ? "scope=snsapi_userinfo&" : ""
      }backUrl=${window.encodeURIComponent(url)}`;
  };

  /**
   * 点击绑定手机号
   */
  const goBindPhone = async () => {
    if (userVisitInfo?.isAuthorized === false) {
      // 如果连openId都没有，需要先授权
      toAuth();
    } else if (userVisitInfo?.isBindPhone === false) {
      // 如果只是没有绑定手机号，需要跳转到绑定手机号页面
      setBindPhonePopupVisible(true);
    }
  };

  const onCopy = e => {
    e.stopPropagation();
    copy(userinfo?.userIdCode || userinfo?.visitorCode);
    Toast.show("复制成功");
  };

  // 手机号绑定成功
  const onFinishBindPhone = () => {
    setBindPhonePopupVisible(false);
  };

  return (
    <div className={styles.userinfo}>
      <div className={styles["userinfo-left"]}>
        {/* 店铺logo */}
        <div className={styles["userinfo-left-avatar-box"]}>
          <img
            className={styles["userinfo-left__avatar"]}
            src={userinfo.headImgUrl || defaultAvatarUrl}
            alt=""
          />
          {userinfo.roleSwitchAvailable && (
            <div className={styles["role-switch"]} onClick={() => setRoleSwitchPoupVisible(true)}>
              <img className={styles["role-switch__icon"]} src={SWITCH} alt="" />
              <span className={styles["role-switch__text"]}>切换身份</span>
            </div>
          )}
        </div>
        {/* 用户信息 */}
        <div className={styles["userinfo-left__name"]}>
          <p>{userinfo.nickname || userinfo.phone}</p>
          {userVisitInfo?.isBindPhone === false && (
            // 未绑定手机号，不管是否是游客
            <div className={styles["bind-phone"]} onClick={goBindPhone}>
              绑定手机
            </div>
          )}
          {userinfo?.currentRole === 1 && labelViewInfo?.labelIconUrl && (
            <div className={styles.label_wrap}>
              <img className={styles.label} src={labelViewInfo.labelIconUrl} />
            </div>
          )}
          {(userinfo?.userIdCode || userinfo?.visitorCode) && (
            <div className={styles["user-id"]} onClick={onCopy}>
              编号: {userinfo?.userIdCode || userinfo?.visitorCode}
              <div className={styles["btn__copy"]}>复制</div>
            </div>
          )}
        </div>
      </div>

      {/* 右侧分享店铺按钮(第三方内嵌场景（app）不支持分享) */}
      <div className={styles["userinfo-right"]}>
        {/* {shareInfo?.shopQrCodeUrl && (
          <div className={styles["userinfo-right__item"]} onClick={handleClickContact}>
            <img src={IWechat} alt="" />
            <span>联系店主</span>
          </div>
        )} */}
        {!isExternal && (
          <div className={styles["userinfo-right__item"]} onClick={handleClickShare}>
            <img src={SHOP} alt="" />
            <span>分享店铺</span>
          </div>
        )}
      </div>

      {/* H5页面分享引导轻提示 */}
      {showGuide && (
        <div className={styles["guide_mask"]} onClick={() => setShowGuide(false)}>
          <img className={styles["guide"]} src={GUIDE} alt="" />
        </div>
      )}

      {/* 店主联系方式二维码组件
      <ShopOwnerQrcode
        visible={contactVisible}
        setVisible={setContactVisible}
        shareInfo={shareInfo}
      /> */}

      {/* 切换身份弹出层 */}
      <RoleSwitchPopup
        userinfo={userinfo}
        visible={roleSwitchPoupVisible}
        setVisible={setRoleSwitchPoupVisible}
        currentRole={userinfo.currentRole}
        onConfirm={handleRoleSwitchConfirm}
      />
      {/* 绑定手机弹出层 */}
      <BindPhonePopup
        visible={bindPhonePopupVisible}
        setVisible={setBindPhonePopupVisible}
        onFinish={onFinishBindPhone}
      />
    </div>
  );
};

export default UserInfo;
